import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Phone, Mail, ArrowLeft, Play } from 'lucide-react'

export default function VideoPage() {
  const title = "Video | Malerfirmaet Villy Poulsen"
  const metaDesc = "Se video af vores professionelle malerarbejde og hør mere om vores ydelser."

  useEffect(() => {
    document.title = title
    const metaDescriptionTag = document.querySelector('meta[name="description"]')
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDesc)
    }
  }, [])

  return (
    <div className="bg-white">
      {/* Banner Header */}
      <section className="relative bg-gray-900 text-white py-20">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/8d7e02f1-9ce4-48ff-8a27-011d8dcadd09.jpeg"
            alt="Video banner"
            className="w-full h-full object-cover opacity-45"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-950/80 via-gray-900/50 to-transparent" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-[#FDF300] bg-[#FDF300]/10 px-3 py-1.5 rounded-full">
            Præsentation
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black mt-4">
            Se vores arbejde her
          </h1>
          <p className="text-gray-300 text-sm sm:text-base mt-2 max-w-xl mx-auto">
            Få et indblik i vores professionelle malerarbejde og hør mere om vores ydelser.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="mb-8">
            <Link to="/om-os" className="inline-flex items-center gap-2 text-sm font-bold text-[#01529E] hover:text-[#01529E]/80 transition-colors">
              <ArrowLeft className="h-4 w-4" />
              Tilbage til Om os
            </Link>
          </div>

          {/* Video Player Container */}
          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl bg-gray-950 border border-gray-200">
            <video
              src="https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/fdf783a9-6d7e-4370-b1f6-7daee1d6deb8.mp4"
              controls
              className="absolute inset-0 w-full h-full object-cover"
              poster="https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/8d7e02f1-9ce4-48ff-8a27-011d8dcadd09.jpeg"
            />
          </div>

          {/* Video Description */}
          <div className="mt-12 text-center max-w-2xl mx-auto">
            <h2 className="text-2xl font-black text-gray-900 mb-4">Kvalitet i bevægelse</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Vores video viser vores dygtige malere i gang med forskellige opgaver. Vi arbejder med sans for detaljerne og sørger for et omhyggeligt arbejde fra den første planlægning til den afsluttende aflevering.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/kontakt" className="px-6 py-3 rounded-xl bg-[#01529E] text-white font-bold text-sm hover:bg-[#01529E]/90 transition-colors shadow-md">
                Få et uforpligtende tilbud
              </Link>
              <a href="tel:40637670" className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 font-bold text-sm hover:bg-gray-200 transition-colors">
                Ring Mobil: 40 63 76 70
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
